import SmartConsentBankingURLView from './SmartConsentBankingURLView';

export default SmartConsentBankingURLView;
